import axios from "axios";

const cache = {};
const graphqlUrl = `${window.location.protocol}//${window.location.host}/graphql`;

const mutation = ({ query, variables = {} }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(graphqlUrl, { query, variables })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const query = ({ query, variables = {} }, options = { cache: true }) => {
  const cacheKey = toCacheKey(query, variables);
  const cacheData = cache[cacheKey];

  return new Promise((resolve, reject) => {
    if (cacheData && options.cache) {
      if (cacheData.loading)
        cacheData.promise.then(data => {
          resolve(data);
        });
      else resolve(cacheData.data);
    } else {
      const cachePromise = new Promise((cacheResolve, cacheReject) => {
        axios
          .post(graphqlUrl, { query, variables })
          .then(response => {
            cache[cacheKey] = response;
            resolve(response.data);
            cacheResolve(response.data);
          })
          .catch(error => {
            reject(error);
            cacheReject(error);
          });
      });
      cache[cacheKey] = { loading: true, promise: cachePromise };
    }
  });
};

const toCacheKey = (query, variables) => `${query.replace(/\s/g, "")}_${JSON.stringify(variables)}`;

export default {
  query,
  mutation,
};
